import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray } from '@angular/forms';
import { sentry } from 'sentry';
import { OutlinedSelectOption } from '../../base/fc-outlined-select/fc-outlined-select.component';
import { FcMaintenanceTypesOutlinedSelectService } from './services/fc-maintenance-types-outlined-select.service';

@Component({
  selector: 'fc-maintenance-types-outlined-select',
  templateUrl: './fc-maintenance-types-outlined-select.component.html'
})
export class FcMaintenanceTypesOutlinedSelectComponent implements OnChanges {
  @Input()
  public required: boolean;

  @Input()
  public findBySegment: boolean;

  @Input()
  public label: string;

  @Input()
  public segmentId: string;

  @Input()
  public control: FormArray;

  public maintenanceTypes: OutlinedSelectOption[];
  public showAllOption: boolean;

  constructor(private readonly fcMaintenanceTypesOutlinedSelectService: FcMaintenanceTypesOutlinedSelectService) {
    this.maintenanceTypes = [];
    this.findBySegment = false;
    this.showAllOption = false;
  }

  public async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (this.findBySegment && changes.segmentId.currentValue !== changes.segmentId.previousValue) {
      await this.searchMaintenanceTypes();
    }
  }

  private async searchMaintenanceTypes(): Promise<void> {
    this.control.clear();
    this.control.disable();
    this.maintenanceTypes = [];

    if (!this.segmentId) {
      return;
    }

    try {
      let results = await this.fcMaintenanceTypesOutlinedSelectService.getMaintenanceTypesBySegmentId(this.segmentId);

      this.showAllOption = !results.length;
      if (!results.length) {
        results = await this.fcMaintenanceTypesOutlinedSelectService.getPaginatedMaintenanceTypes();
      }

      this.maintenanceTypes = results.map((item) => ({
        text: item.name,
        value: item
      }));
    } catch (err) {
      sentry.captureException(err);
    } finally {
      this.control.enable();
    }
  }
}
